import React from 'react';
import { Dropdown } from 'primereact/dropdown';
import { Skeleton } from 'primereact/skeleton';
import styles from '../stylesheets/TelegramBotSelector.module.css';

const TelegramBotSelector = ({
  botConfigs = [],
  selectedBotConfigId,
  onChange,
  loading = false,
  showLabel = true,
  className = '',
}) => {
  if (loading) {
    return (
      <div className={`${styles.wrapper} ${className}`}>
        {showLabel && <label className={styles.label}>Bots</label>}
        <Skeleton width="100%" height="2.5rem" />
      </div>
    );
  }

  if (!botConfigs.length) {
    return (
      <div className={`${styles.wrapper} ${className}`}>
        {showLabel && <label className={styles.label}>Bots</label>}
        <span className={styles.empty}>No Telegram bots found</span>
      </div>
    );
  }

  const dropdownOptions = botConfigs.map((config) => ({
    value: config.id,
    label: `@${config.userName}`,
  }));

  return (
    <div className={`${styles.wrapper} ${className}`}>
      {showLabel && <label className={styles.label}>Bots</label>}

      <Dropdown
        value={selectedBotConfigId}
        options={dropdownOptions}
        optionLabel="label"
        onChange={(e) => onChange(e.value)}
        placeholder="Select Telegram Bot"
        className="w-full md:w-20rem"
        panelClassName={styles.panel}
        itemTemplate={(option) => (
          <div className={styles.option}>
            <span className={styles.optionName}>{option.label}</span>
          </div>
        )}
        valueTemplate={(option) =>
          option ? (
            <div className={styles.option}>
              <span className={styles.optionName}>{option.label}</span>
            </div>
          ) : (
            <span>Select Telegram Bot</span>
          )
        }
      />
    </div>
  );
};

export default TelegramBotSelector;
